module.exports = __webpack_public_path__ + "img/ShirleyLiuPhD.b4c0f56d.png";